"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSFER_PARENT_DESCRIPTION_COPY = exports.INCOME_PARENT_DESCRIPTION_COPY = void 0;
/**
 * The review wizard's two non-spending types (BEN-141 FP-023 residual).
 *
 * Both clients' wizards offered only the three spending buckets, while the
 * categorise sheet offers all five, so a move between the user's own accounts could not
 * be filed as a Transfer from the review queue. Paul (2026-10-06): add Income and
 * Transfer on both clients, with FP-054's confirm for an outflow filed as Income.
 * Each type card carries a one-line description; these are the two new ones.
 */
exports.INCOME_PARENT_DESCRIPTION_COPY = "Money you earn or receive as pay.";
// Your OWN accounts (web's rule-17 note): paying a person by Venmo or Zelle is
// spending, and anything filed as Transfer leaves every spending figure.
exports.TRANSFER_PARENT_DESCRIPTION_COPY = "Money moved between your own accounts, not spending.";
//# sourceMappingURL=wizardParentCopy.js.map